/*
 * @Author: Wu Yinglei
 * @Date: 2021-08-12 13:41:31
 * @LastEditors: Wu Yinglei
 * @LastEditTime: 2021-08-16 13:41:23
 * @Description: 
 * @FilePath: \lab820\src\main.js
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueStorage from 'vue-ls'
import './libs/rem'
import "ant-design-vue/dist/antd.css";
import Vant from 'vant';
import 'vant/lib/index.css';
import vueEsign from 'vue-esign'
Vue.use(Vant)
Vue.use(vueEsign)

import { Input, Checkbox, Radio, Button, Icon, Row, Col, Divider, Carousel, Modal, DatePicker, message, Spin, FormModel, Select } from 'ant-design-vue'

Vue.use(Input).use(Checkbox).use(Radio).use(Button).use(Icon).use(Row).use(Col).use(Divider).use(Carousel).use(Modal).use(DatePicker).use(Spin).use(FormModel).use(Select)
const options = {
  namespace: 'pro__', // key prefix
  name: 'ls', // name variable Vue.[ls] or this.[$ls],
  storage: 'local' // storage name session, local, memory
}
Vue.config.productionTip = false
Vue.use(VueStorage, options)
Vue.prototype.$message = message

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js